/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EquipmentBrowserView,
  EquipmentBrowserView$inboundSchema,
} from "./equipmentbrowserview.js";
import { SummaryConfig, SummaryConfig$inboundSchema } from "./summaryconfig.js";

/**
 * The response to a request for the equipment browser view configuration.
 */
export type EquipmentBrowserViewResponse = {
  /**
   * The summary configurations of the equipment browser view.
   */
  summaryConfigs: Array<SummaryConfig>;
  view: EquipmentBrowserView;
};

/** @internal */
export const EquipmentBrowserViewResponse$inboundSchema: z.ZodType<
  EquipmentBrowserViewResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  summary_configs: z.array(SummaryConfig$inboundSchema),
  view: EquipmentBrowserView$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "summary_configs": "summaryConfigs",
  });
});

export function equipmentBrowserViewResponseFromJSON(
  jsonString: string,
): SafeParseResult<EquipmentBrowserViewResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EquipmentBrowserViewResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EquipmentBrowserViewResponse' from JSON`,
  );
}
